import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ForgotService } from "../shared/Forgot.Service";
import { AppInsightsService } from "../shared/AppInsights.Service";

@Component({
  selector: "app-identity-mgt-advisor",
  templateUrl: "./identity-mgt-advisor.component.html",
  styleUrls: ["./identity-mgt-advisor.component.scss"]
})
export class IdentityMgtAdvisorComponent implements OnInit {
  public type = "apwd";
  categories: {};
  selection = { name: "" };

  constructor(
    private router: Router,
    private forgotService: ForgotService,
    private appInsightsService: AppInsightsService
  ) {}

  ngOnInit() {
    window.scroll(0, 0);
    this.appInsightsService.logEvent("Forgot UI Page - Advisor");
    this.forgotService.getType().subscribe(res => {
      this.type = res;
    });
  }
}
